import { Lesson } from '../../../../types';
const lesson: Lesson = { itemId: '2084285', title: 'Os 3 Pilares do Trader', video: { platform: 'youtube', videoId: 'wRxhpk75aBE' }, article: [
    `<header style="margin-bottom:20px;">
  <h1 style="margin:0 0 8px;font-size:22px;color:#111;">Comece a operar com a <span style="font-family:monospace;">XXBroker</span></h1>
  <p style="margin:0 0 20px;color:#555;line-height:1.5;">
    Para começar a lucrar com Opções Binárias, é <strong>obrigatório</strong> criar sua conta na corretora recomendada pelo link abaixo.
  </p>
  <div style="display:flex;flex-wrap:wrap;gap:10px;">
    <a href="https://xxbroker.com" target="_blank" style="background:#3b82f6;color:#fff;padding:10px 14px;text-decoration:none;border-radius:8px;font-weight:600;">🚀 Criar conta na XXBroker</a>
    <a href="https://www.instagram.com/xxbroker_official?igsh=d2p4ODU0MDY2Nmgx" target="_blank" style="background:#f3f4f6;color:#111;padding:10px 14px;text-decoration:none;border-radius:8px;font-weight:600;">🟣 Instagram @xxbroker_official</a>
    <a href="https://t.me/trendingbrazil" target="_blank" style="background:#22c55e;color:#fff;padding:10px 14px;text-decoration:none;border-radius:8px;font-weight:600;">🔵 Canal do Telegram</a>
  </div>
</header>

<section style="border-radius:12px;padding:16px;margin-bottom:16px;">
  <h2 style="margin:0 0 10px;font-size:18px;color:#111;">Agenda de Lives &amp; Sinais</h2>
  <p style="margin:0 0 10px;color:#555;font-size:14px;line-height:1.4;">
    De <strong>segunda a sexta</strong>, em três janelas: <strong>10:30</strong>, <strong>12:15</strong> e <strong>19:30</strong> — operações ao vivo e envio de sinais no nosso canal.
  </p>
  <ul style="margin:0;padding-left:18px;color:#333;font-size:14px;line-height:1.6;">
    <li>🔵 Canal no Telegram: <a href="https://t.me/trendingbrazil" target="_blank" style="color:#3b82f6;text-decoration:none;">t.me/trendingbrazil</a></li>
    <li>🟣 Instagram oficial: <a href="https://www.instagram.com/xxbroker_official?igsh=d2p4ODU0MDY2Nmgx" target="_blank" style="color:#3b82f6;text-decoration:none;">@xxbroker_official</a></li>
    <li>🌐 Site: <a href="https://xxbroker.com" target="_blank" style="color:#3b82f6;text-decoration:none;">xxbroker.com</a></li>
  </ul>
</section>

<section style="border-radius:12px;padding:16px;margin-bottom:16px;">
  <h3 style="margin:0 0 8px;font-size:16px;color:#111;">Notas rápidas</h3>
  <p style="margin:0;color:#555;font-size:13px;line-height:1.4;">
    Conteúdos e sinais são destinados a fins educacionais. Operar em mercados financeiros envolve riscos; nunca invista valores que não possa perder.
  </p>
</section>

<footer style="margin-top:20px;font-size:12px;color:#777;">
  Atualizado em 05/09/2025 09:41 — Fonte dos contatos compartilhada por Diego Aguiar.
</footer>
`,
  ] };
export default lesson;

